const SHOP_PREFIX = '/shop';

/**
 * Taxonomy PLP `url` values from Contentstack are path-only (e.g. `/shop/baby%20%26%20child`).
 * Segment parsing uses the raw path string so percent-encoding is preserved.
 */

/** True when the path is `/shop/{level1}` or deeper; excludes bare `/shop`. */
export const isShopTaxonomySitemapPath = (path: string): boolean => {
  if (!path.startsWith(`${SHOP_PREFIX}/`)) {
    return false;
  }

  const segments = path.split('/').filter(Boolean);
  return segments[0] === 'shop' && segments.length >= 2;
};

/** First segment after `/shop/`, e.g. `/shop/baby%20%26%20child/...` → `baby%20%26%20child`. */
export const parseShopLevel1Segment = (path: string): string | null => {
  if (!isShopTaxonomySitemapPath(path)) {
    return null;
  }

  const segments = path.split('/').filter(Boolean);
  return segments[1] ?? null;
};

export const shopLevel1Path = (level1Segment: string): string => `${SHOP_PREFIX}/${level1Segment}`;

/** Human-readable label for a level-1 path segment (decode only; links keep raw CMS paths). */
export const formatShopLevel1SegmentLabel = (level1Segment: string): string => {
  try {
    return decodeURIComponent(level1Segment);
  } catch {
    return level1Segment;
  }
};
